import { useCustomersContext } from '@src/hooks/useCustomer';
import { IconName, useObservableValue, type FilterableSelectProperty } from '@talos/kyoko';
import { useMemo } from 'react';

export function useCustomerRolesFilter(): FilterableSelectProperty<'Roles', string> {
  const { customerRoles } = useCustomersContext();
  const customerRolesValue = useObservableValue(() => customerRoles, [customerRoles]);

  return useMemo((): FilterableSelectProperty<'Roles', string> => {
    const roles = customerRolesValue ?? [];
    const rolesByName = new Map(roles.map(role => [role.Name, role]));
    const roleNames = roles
      .toSorted((a, b) => (a.DisplayName ?? a.Name).localeCompare(b.DisplayName ?? b.Name))
      .map(role => role.Name);

    return {
      key: 'Roles',
      label: 'Roles',
      icon: IconName.ShieldCheck,
      control: 'multi-select',
      options: roleNames,
      getOptionLabel: name => rolesByName.get(name)?.DisplayName ?? name,
    };
  }, [customerRolesValue]);
}
